import { Module } from "vuex"
import { RootState } from "../index"
import location, { LocationState } from "./modules/location"
import device, { DeviceState } from "./modules/device"
import user, { UserState } from "./modules/user"
import wizard, { WizardState } from "./modules/wizard"
import tariff, { TariffState } from "./modules/tariff"

export interface SetupModuleState {
    location: LocationState
    device: DeviceState
    user: UserState
    wizard: WizardState
    tariff: TariffState
}

const setupModule: Module<SetupModuleState, RootState> = {
    namespaced: true,
    modules: {
        location,
        device,
        user,
        wizard,
        tariff,
    },
    state: {} as SetupModuleState,
}

export default setupModule
